module.exports = __webpack_public_path__ + "img/icon-menu.f992e792.svg";